import { jsx as l } from "react/jsx-runtime";
import "react";
var i = (a) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  fill: "none",
  viewBox: "0 0 21 21",
  ...a,
  children: /* @__PURE__ */ l("path", {
    fill: "#2d2d3a",
    fillRule: "evenodd",
    d: "M14.126 20.326a20.04 20.04 0 0 1-8.718-5.128A20.04 20.04 0 0 1 .28 6.48l-.016-.057C.116 5.904.002 5.502 0 4.95a4.4 4.4 0 0 1 .513-1.97C1.043 2.032 2.185.82 3.17.322a3 3 0 0 1 2.708 0c.842.426 1.78 1.38 2.303 2.184a3 3 0 0 1 0 3.27c-.173.267-.42.513-.707.8-.089.089-.187.153-.122.289a13.6 13.6 0 0 0 2.652 3.735 13.6 13.6 0 0 0 3.736 2.652c.14.068.196-.028.289-.122.286-.287.533-.534.8-.707a3 3 0 0 1 3.27 0c.782.51 1.76 1.468 2.183 2.303a3 3 0 0 1 0 2.709c-.498.985-1.71 2.126-2.656 2.657a4.36 4.36 0 0 1-1.97.512c-.553-.001-.955-.116-1.474-.263z",
    clipRule: "evenodd"
  })
});
export {
  i as default
};
